export const vehicalInspectionList = [
  {
    key: 'goodVisibility',
    label:
      'Good visibility for driver correctly. through all cab windows and mirrors. All required mirrors fitted and adjusted',
  },
  { key: 'drivingControls', label: 'Driving controls, seat and driver safety belt adjusted correctly.' },
  { key: 'windscreenWasher', label: 'Windscreen washer, wipers, demister and horn operating correctly.' },
  {
    key: 'allInstruments',
    label:
      'All instruments, gauges lights). and other warning devices operating correctly (including ABS/EBS in-cab warning',
  },
  { key: 'cabClean', label: 'Cab clean with no obstructions or loose material.' },
  { key: 'highVisibility', label: 'High visibility jacket/vest accessible in cab.' },
  { key: 'vehicleSitting', label: 'Vehicle sitting square and not leaning to one side.' },
  {
    key: 'taxInsurance',
    label: 'Tax, insurance and transport (if applicable) discs present and valid. Number plates clearly visible.',
  },
  {
    key: 'wheelsCondition',
    label: 'Wheels in good condition and secure.Tyres undamaged with correct inflation and tread depth.',
  },
  { key: 'allLights', label: 'All lights and reflectors fitted, clean and in good condition.' },
  { key: 'exhaustSecure', label: 'Exhaust secure with no excess noise or smoke.' },
  { key: 'vehicleAccess', label: 'Vehicle access, doors, steps and bodywork in good condition.' },
  { key: 'fuelCapSeal', label: 'Fuel cap seal in place and not leaking.' },
  { key: 'engineOil', label: 'Engine oil, water, windscreen washer reservoir and fuel levels checked and no leaks.' },
  { key: 'steeringBrakes', label: 'Steering and brakes operating correctly.' },
  { key: 'loadWithinLimits', label: 'Load within limits, secured and weight distributed correctly.' },
  { key: 'abS_EBS', label: 'ABS/EBS warning lights off.' },
];

export const harvestingMaintanceVehicalCheckListoptionList = [
  {
    key: 'harvestingMaintenanceFillDiesel',
    label: 'Fill Diesel',
  },
  {
    key: 'harvestingMaintenanceGreaseHeads',
    label: 'Grease Heads',
  },
  {
    key: 'harvestingMaintenanceGreaseCrane',
    label: 'Grease Crane',
  },
  {
    key: 'harvestingMaintenanceGreaseBaseUnit',
    label: 'Grease Base Unit',
  },
  {
    key: 'harvestingMaintenanceCheckEngineOilLevel',
    label: 'Check Engine Oil Level',
  },
];

export const forwardingMaintanceVehicalCheckListoptionList = [
  {
    key: 'forwardingMaintenanceFillDiesel',
    label: 'Fill Diesel',
  },

  {
    key: 'forwardingMaintenanceGreaseGrab',
    label: 'Grease Heads',
  },
  {
    key: 'forwardingMaintenanceGreaseCrane',
    label: 'Grease Crane',
  },
  {
    key: 'forwardingMaintenanceGreaseBaseUnit',
    label: 'Grease Base Unit',
  },
  {
    key: 'forwardingMaintenanceCheckEngineOilLevel',
    label: 'Check Engine Oil Level',
  },
];

/*

forwardingMaintenanceCheckEngineOilLevel
: 
"Completed"
forwardingMaintenanceFillDiesel
: 
"Completed"
forwardingMaintenanceGreaseBaseUnit
: 
"Not Completed"
forwardingMaintenanceGreaseCrane
: 
"Completed"
forwardingMaintenanceGreaseGrab


*/
